export const settingEnum = {
  JobTitle: 0,//Chức vụ
  TaskType: 1, // Loại công việc
  PriorityLevel: 2, // Mức độ ưu tiên
  RatingTask: 3, // Đánh giá công việc
  Deadline: 4 // Thời gian quá hạn
};